import { Link } from "react-router-dom";
import { BRAND } from "@/lib/constants";
import { Instagram, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative overflow-hidden bg-midnight text-cream-50 mt-16 md:mt-32"
    >
      <div className="page-shell py-14 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
        <div className="md:col-span-5">
          <div className="font-display text-4xl sm:text-5xl md:text-6xl font-light leading-[1.05] tracking-normal">
            Ruhunla
            <br />
            <em className="text-gold-soft font-light">tanışmanın</em> zamanı.
          </div>
          <Link
            to="/randevu"
            data-testid="footer-cta-appointment"
            className="inline-flex items-center gap-3 mt-8 md:mt-10 text-cream-50 border-b border-gold pb-1 text-xs sm:text-sm tracking-[0.16em] md:tracking-[0.22em] uppercase hover:text-gold-soft transition-colors duration-500"
          >
            Randevu Al &nbsp;→
          </Link>
        </div>

        <div className="md:col-span-3 md:col-start-7">
          <div className="text-[10px] tracking-[0.4em] uppercase text-gold mb-5">
            Sayfalar
          </div>
          <ul className="space-y-3 font-display text-2xl text-cream-100/90">
            <li><Link to="/" className="hover:text-gold-soft">Anasayfa</Link></li>
            <li><Link to="/hakkinda" className="hover:text-gold-soft">Hakkımda</Link></li>
            <li><Link to="/hizmetler" className="hover:text-gold-soft">Hizmetler</Link></li>
            <li><Link to="/iletisim" className="hover:text-gold-soft">İletişim</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] tracking-[0.4em] uppercase text-gold mb-5">
            İletişim
          </div>
          <ul className="space-y-4 text-cream-100/80 text-sm">
            <li className="flex items-center gap-3"><Phone size={14} className="text-gold-soft" />{BRAND.displayPhone}</li>
            <li className="flex items-center gap-3 min-w-0"><Mail size={14} className="text-gold-soft shrink-0" /><span className="break-all">{BRAND.email}</span></li>
            <li className="flex items-center gap-3"><Instagram size={14} className="text-gold-soft" />{BRAND.instagram}</li>
            <li className="pt-3 text-xs text-cream-100/50 italic font-display">{BRAND.city}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-cream-100/10">
        <div className="page-shell py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-center md:text-left text-[10px] sm:text-[11px] text-cream-100/50 tracking-[0.12em] md:tracking-[0.2em] uppercase">
          <div>© {new Date().getFullYear()} {BRAND.name}</div>
          <div className="mt-3 md:mt-0">Sezgi · Zarafet · Dönüşüm</div>
        </div>
      </div>
    </footer>
  );
}
